<template>
	<VsIcon class="h-8 w-11" v-if="teamPlayers > 1" v-bind="$attrs" />
	<div class="w-fit rounded-full bg-[#121212] p-0.5" v-else v-bind="$attrs">
		<div
			class="bg-fill-secondary text-label-primary flex h-7 items-center rounded-full border-2 border-black px-2.5 text-xs font-medium uppercase"
		>
			vs
		</div>
	</div>
</template>
<script setup lang="ts">
import VsIcon from '@/assets/icons/vs.svg'

defineProps<{
	teamPlayers: number
}>()
</script>
